@if (isVisible) {
  <div class="loading-indicator container"
    [class.inline]="inline">
  </div>
  <div class="loading-indicator indicator"
    [class.inline]="inline">
    <svg-icon src="assets/icons/circle-notch-solid.svg"
    class="eshava-ascent-svg"></svg-icon>
  </div>
}